import { useEffect } from 'react'

const Splash = ({ onDone, duration = 1500 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDone?.()
    }, duration)
    return () => clearTimeout(timer)
  }, [onDone, duration])

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="animate-fade-in">
        <img src="/splash.png" alt="Novatarra splash" className="w-32 h-32 object-contain" />
      </div>
    </div>
  )
}

export default Splash










